import { render, staticRenderFns } from "./accessory-card.vue?vue&type=template&id=5465c31c&scoped=true&"
import script from "./accessory-card.vue?vue&type=script&lang=js&"
export * from "./accessory-card.vue?vue&type=script&lang=js&"
import style0 from "./accessory-card.vue?vue&type=style&index=0&id=5465c31c&lang=scss&scoped=true&"
import style1 from "./accessory-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465c31c",
  null
  
)

export default component.exports